import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useMainContext } from '@/context/main-context';
import { formatDate } from '@/lib/utils';
import { Activity, Calendar } from 'lucide-react';
import { Badge } from '../ui/badge';

function GroupHeader({ group }) {
  const { teacherData, courses } = useMainContext();

  const course = courses?.find((item) => item.id === group?.courseId);
  const courseTitle = course?.courseTitle || 'Kurs topilmadi';
  const groupNumber = group?.groupNumber || '';
  const displayName = groupNumber
    ? `${courseTitle} #${groupNumber}`
    : courseTitle;

  return (
    <div className="space-y-2 py-4 w-full border-b border-border">
      <div className="flex items-center gap-2">
        <h1 className="text-xl md:text-2xl font-semibold">
          {displayName}
        </h1>
        <Badge
          variant={group.status ? 'active' : 'inactive'}
          className={`flex items-center gap-1 !text-xs md:text-sm ${group.status ? 'text-green-500' : 'text-red-500'
            }`}
        >
          <Activity className="w-3 h-3" />
          <span>{group.status ? 'Aktiv' : 'Tugatildi'}</span>
        </Badge>
      </div>
      <div className="flex items-center gap-3 md:gap-5">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Badge
                variant={group.dayType === 'odd' ? 'odd' : 'even'}
                className="flex items-center gap-1 whitespace-nowrap"
              >
                <span className="text-xs">
                  {group.dayType === 'odd'
                    ? 'Toq kunlar'
                    : group.dayType === 'even'
                      ? 'Juft kunlar'
                      : ''}
                </span>
                -
                <span className="text-xs">
                  {group.timeInDay
                    ? group.timeInDay
                    : `${group.from || ''} - ${group.to || ''}`}{' '}
                </span>
              </Badge>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="text-xs font-medium text-accent-foreground">
                {group.dayType === 'odd'
                  ? 'Du - Chor - Ju'
                  : group.dayType === 'even'
                    ? 'Se - Pay - Shan'
                    : ''}
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <div className="flex items-center gap-1 text-xs md:text-sm text-muted-foreground">
          <Calendar className="w-4 h-4" />
          <span>{formatDate(group.startDate)}</span>
        </div>
      </div>
    </div>
  );
}

export default GroupHeader;
